/** 達人主頁（t('creator.…')） */
export default {
	breadcrumb: "達人主頁",
	pageTitle: "達人主頁 - 先知命局",
	likes: "獲讚",
	followers: "追蹤者",
	privateChat: "私聊",
	introEmpty: "暫無簡介",
	tabVideo: "視頻",
	tabArticle: "文章",
	videoEmpty: "暫無視頻",
	articleEmpty: "暫無文章",
	loadMore: "加載更多",
};
